export const readFileAsDataUrl = file => {
  return new Promise(resolve => {
    const reader = new window.FileReader()
    reader.addEventListener(
      'load',
      () => {
        resolve(reader.result)
      },
      false
    )
    reader.readAsDataURL(file)
  })
}

export const splitDataUrl = dataUrl => {
  const m = /data:([^;]+);base64,(.+)/.exec(dataUrl)
  let mimeType = ''
  let data = ''
  if (m) {
    mimeType = m[1]
    data = m[2]
  }
  return { mimeType, data }
}

export const readFile = file => {
  return readFileAsDataUrl(file)
    .then(splitDataUrl)
    .then(({ mimeType, data }) => ({
      mimeType,
      fileContent: data
    }))
}

export const KB = 1024
export const MB = 1024 * 1024

export const formatFileSize = size => {
  if (size >= MB) {
    return `${Math.round(size / MB)} MB`
  }
  if (size >= KB) {
    return `${Math.round(size / KB)} KB`
  }
  return `${size} B`
}

export default {
  readFileAsDataUrl,
  splitDataUrl,
  readFile,
  formatFileSize,
  KB,
  MB
}
